/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Analysis_CompleteInputs */

const en_onboarding_analysis_complete = /** @type {(inputs: Onboarding_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis Complete!`)
};

const es_onboarding_analysis_complete = /** @type {(inputs: Onboarding_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Análisis completo!`)
};

/**
* | output |
* | --- |
* | "Analysis Complete!" |
*
* @param {Onboarding_Analysis_CompleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_analysis_complete = /** @type {((inputs?: Onboarding_Analysis_CompleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Analysis_CompleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_analysis_complete(inputs)
	return en_onboarding_analysis_complete(inputs)
});